import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Select, message, InputNumber } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DataService } from '../../config/dataService/dataService';

export default function EditModal({ isModalOpen, setIsModalOpen, selelectedRow, getUsersApplicationDetails }) {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [submittable, setSubmittable] = React.useState(false);
  const [bitfinexUrl, setBitfinexUrl] = useState('');
  const [numberOfFamilies, setNumberOfFamilies] = useState([]);
  const [data, setData] = useState();

  // Watch all values
  const watch = Form.useWatch([], form);

  React.useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      },
    );
  }, [watch]);

  useEffect(() => {
    console.log('selected row', selelectedRow);
    if (
      selelectedRow?.paymentDetails?.paymentType &&
      selelectedRow?.paymentDetails?.TransactionId &&
      selelectedRow?.paymentDetails?.residentType
    ) {
      form.setFieldValue('residentType', selelectedRow.paymentDetails.residentType);
      form.setFieldValue('paymentType', selelectedRow.paymentDetails.paymentType);
      form.setFieldValue('TransactionId', selelectedRow.paymentDetails.TransactionId);
    } else {
      form.setFieldValue('residentType', '');
      form.setFieldValue('paymentType', '');
      form.setFieldValue('TransactionId', '');
    }
  }, [selelectedRow]);

  const handleUpdate = () => {
    if (data.paymentType === '') {
      message.error('Please choose the payment type');
      return;
    }
    const body = {
      email: selelectedRow.email,
      name: selelectedRow.name,
      phoneNumber: selelectedRow.phoneNumber,
      paymentDetails: {
        residentType: data?.residentType,
        paymentType: data?.paymentType,
      },
    };
    setLoading(true);
    DataService.patch(`/userApplications/${selelectedRow._id}`, body)
      .then(async () => {
        const nationData = await DataService.get(`/country/code/${selelectedRow.nationality}`);
        const countryData = await DataService.get(`/country/code/${selelectedRow.resid_country}`);
        const invoiceData = {
          amount: String(data.amount),
          currency: 'USD',
          duration: process.env.REACT_APP_PASSPORT_PAYMENT_DURATION,
          nationality: nationData.data.code,
          residCountry: countryData.data.code,
          residStreet: selelectedRow.resid_street,
          residZipCode: selelectedRow.resid_zipcode,
          residBuildingNo: selelectedRow.resid_building_name,
          residCity: selelectedRow.resid_city,
          fullName: selelectedRow.name,
          email: selelectedRow.email,
          paymentType: 'PassportPayment',
          userId: selelectedRow.userId,
        };
        // Hotfix applied on 24th jan for USA (Renounced Citizenship)
        if (invoiceData.nationality === '840') {
          invoiceData.nationality = invoiceData.residCountry;
        }
        console.log('invoice data', invoiceData);
        await DataService.post('/bitfinex/submitInvoice', invoiceData)
          .then((resInvoice) => {
            if (resInvoice.status === 201) {
              const url = `https://pay.bitfinex.com/gateway/order/${resInvoice.data}`;
              setBitfinexUrl(url);
            } else {
              message.error(t('unknown_error_message'));
            }
            // const windowFeatures = 'width=600,height=800,resizable,scrollbars';
            // window.open(url, '_blank', windowFeatures);
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });

        // setIsModalOpen(false);
        getUsersApplicationDetails();
        form.resetFields();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleChange = (value) => {
    setData((prev) => {
      return { ...prev, ...value };
    });
  };

  useEffect(() => {
    if (process.env.REACT_APP_MAX_CHILD_LIMIT) {
      const familiesList = [];
      let obj;
      for (let i = 0; i <= Number(process.env.REACT_APP_MAX_CHILD_LIMIT) + 1; i += 1) {
        obj = {
          value: i,
          label: i,
        };
        familiesList.push(obj);
      }
      setNumberOfFamilies(familiesList);
    }
  }, []);

  useEffect(() => {
    if (form.getFieldValue('numberOfMembers') || form.getFieldValue('numberOfMembers') === 0) {
      const familyAmount =
        Number(form.getFieldValue('numberOfMembers')) * Number(process.env.REACT_APP_APPLICATION_FEE);
      const totalAmount = familyAmount + 999001;
      setData((prev) => {
        return { ...prev, amount: totalAmount };
      });
      form.setFieldValue('amount', totalAmount);
    }
  }, [form.getFieldValue('numberOfMembers')]);

  useEffect(() => {
    if (!isModalOpen) {
      setBitfinexUrl('');
    }
  }, [isModalOpen]);

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Modal
      width="30%"
      title={bitfinexUrl ? 'Success' : 'Update'}
      open={isModalOpen}
      footer={null}
      onCancel={() => {
        setIsModalOpen(false);
        form.resetFields();
      }}
    >
      {bitfinexUrl ? (
        <div className="justify-content-center flex-col">
          <h3 className="">{t('You have submitted the Application.')}</h3>
          <p className="">
            {t('After completing the payment through ')}{' '}
            <a target="_blank" href={bitfinexUrl} rel="noreferrer">
              {t('this link')}
            </a>
            {t(', the application review process will begin.')}
          </p>
        </div>
      ) : (
        <Form
          layout="vertical"
          className="add-new-wallet"
          form={form}
          onValuesChange={handleChange}
          onFinish={handleUpdate}
        >
          <div className="d-flex justify-content-center">
            <Form.Item
              name="residentType"
              label={t('Select Resident Type')}
              style={{ width: '100%' }}
              rules={[
                {
                  required: true,
                  message: 'Please select resident type',
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option value="" defaultValue="">
                  {t('Select one')}
                </Option>
                <Option value="Freedom Visa">{t('Freedom Passport')}</Option>
              </Select>
            </Form.Item>
          </div>
          <div className="d-flex justify-content-center">
            <Form.Item
              name="numberOfMembers"
              label={t('Select Number of family members')}
              style={{ width: '100%' }}
              rules={[
                {
                  required: true,
                  message: 'Please select number of family member',
                },
              ]}
            >
              <Select
                placeholder="Select number of families member"
                filterOption={filterOption}
                options={numberOfFamilies}
              />
            </Form.Item>
          </div>
          <div className="d-flex justify-content-center">
            <Form.Item
              name="amount"
              label={t('Amount')}
              style={{ width: '100%' }}
              rules={[
                {
                  required: true,
                  message: 'Please Input Amount',
                },
              ]}
            >
              <InputNumber
                placeholder={t('Amount')}
                formatter={(value) => `${value ? '$' : ''}${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value?.replace(/\$\s?|(,*)/g, '')}
              />
            </Form.Item>
          </div>
          <Button type="primary" htmlType="submit" disabled={loading || !submittable || !form.getFieldValue('amount')}>
            {loading ? 'Loading...' : 'Submit Payment'}
          </Button>
        </Form>
      )}
    </Modal>
  );
}

EditModal.propTypes = {
  isModalOpen: PropTypes.bool,
  setIsModalOpen: PropTypes.func,
  // form: PropTypes.any,
  selelectedRow: PropTypes.any,
  getUsersApplicationDetails: PropTypes.func,
};
